const SELECTED_LANGUAGE = 'nb';

export default SELECTED_LANGUAGE;
